import { withStyles } from '@material-ui/styles';
import React, { Fragment } from 'react';
import EntregaView from './EntregaView';
import ExportadorView from './ExportadorView';
import FacturasView from './FacturasView';
import ImportadorView from './ImportadorView';
import MercaderiasView from './MercaderiasView';

const styles = theme => ({
  inputGroup: {
    paddingTop: theme.spacing(2),
    paddingBottom: theme.spacing(2)
  }
});

const Pasos = ({ isPhone, classes, baseObject, ...props }) => {
  const gridProps = {
    spacing: 3,
    className: classes.inputGroup
  };

  const stepProps = {
    ...props,
    gridProps
  };

  const steps = [
    {
      label: 'Exportador',
      key: 'exportador',
      content: <ExportadorView values={baseObject} isPhone={isPhone} />
    },
    {
      label: 'Imporador',
      key: 'importador',
      content: <ImportadorView values={baseObject} isPhone={isPhone} />
    },
    {
      label: 'Facturas',
      key: 'facturas',
      content: (
        <FacturasView {...stepProps} values={baseObject} isPhone={isPhone} />
      )
    },
    {
      label: 'Mercaderías',
      key: 'mercaderias',
      content: (
        <MercaderiasView {...stepProps} values={baseObject} isPhone={isPhone} />
      )
    },
    {
      label: 'Entrega',
      key: 'entrega',
      content: (
        <EntregaView {...stepProps} values={baseObject} isPhone={isPhone} />
      )
    }
  ];

  return (
    <>
      {steps.map(item => (
        <Fragment key={item.key}>{item.content}</Fragment>
      ))}
    </>
  );
};

export default withStyles(styles)(Pasos);
